
import { Vue, Component, Prop, PropSync, Watch } from "vue-property-decorator";

@Component({
  name: "TableMedia",
  components: {},
})
export default class TableMedia extends Vue {
  @Prop({ type: Array }) tableData!: any;
  @Prop({ type: Boolean }) loading!: any;
  handleClick(item: any) {
    this.$emit("handleClick", item);
  }
}
